// @flow
import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'

import styles from './show-more.module.scss'

interface Props {
  className?: string
  more: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (e: any) => void
}

const ShowMore = ({ className = '', more, onChange }: Props) => (
  <div
    className={classnames('ps-relative tx-center', className, styles.show, {
      [styles.more]: !more,
    })}
  >
    {more ? (
      <button
        type="button"
        // eslint-disable-next-line max-len
        className={`less btn-chromeless tx-oswald tx-12 tx-w300 py-3 ${styles.button}`}
        onClick={() => onChange(false)}
      >
        <i className="solicon-angle-up d-block" />
        <span>
          <FormattedMessage id="app.show.less" defaultMessage="Show Less" />
        </span>
      </button>
    ) : (
      <button
        type="button"
        className={`more btn-chromeless tx-oswald tx-12 tx-w300 ${styles.button}`}
        onClick={() => onChange(true)}
      >
        <span>
          <FormattedMessage id="app.show.more" defaultMessage="Show More" />
        </span>
        <i className="solicon-angle-down d-block" />
      </button>
    )}
  </div>
)

export default ShowMore
